import { render, staticRenderFns } from "./ImsInfoManagement.vue?vue&type=template&id=ef98a53c&"
import script from "./ImsInfoManagement.vue?vue&type=script&lang=js&"
export * from "./ImsInfoManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports